import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/zh-cn';
import relativeTime from 'dayjs/plugin/relativeTime';
import { useEffect, useState } from 'react';

dayjs.extend(relativeTime);

type RelativeTimeValue = string | number | Date | Dayjs;

interface RelativeTimeProps {
  value?: RelativeTimeValue | null;
  /** 是否显示未来时间，例如“3分钟后” */
  future?: boolean;
}

function getNextUpdateInterval(value: Dayjs) {
  const diff = Math.abs(dayjs().diff(value, 'second'));

  // fromNow() 在这些时间点附近会发生文本变化：
  // 几秒前 -> 1分钟前 -> 2分钟前 -> ...
  if (diff < 60) {
    return 1000;
  }

  // 分钟级：每分钟更新即可
  if (diff < 60 * 60) {
    return 60 * 1000;
  }

  // 小时级
  if (diff < 24 * 60 * 60) {
    return 60 * 60 * 1000;
  }

  // 天以上
  return 24 * 60 * 60 * 1000;
}

export function RelativeTime({ value, future = false }: RelativeTimeProps) {
  const [, setTick] = useState(0);

  useEffect(() => {
    if (!value) {
      return;
    }

    let timer: number;

    const schedule = () => {
      const date = dayjs(value);

      timer = window.setTimeout(() => {
        setTick(tick => tick + 1);
        schedule();
      }, getNextUpdateInterval(date));
    };

    schedule();

    return () => {
      window.clearTimeout(timer);
    };
  }, [value]);

  if (!value) {
    return null;
  }

  const date = dayjs(value).locale('zh-cn');

  return <>{future ? date.toNow() : date.fromNow()}</>;
}
